module.exports = __webpack_public_path__ + "static/laoch-640b8ac455a9cd07d63b01d626b4300b.png";